import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getCommonPageText } from '../../utils/sitePolicy';
import Spinner from '../Spinner';


class CommonPageText extends Component {
  state = {
    pageText: undefined,
    isLoading: true,
  };

  componentDidMount() {
    const { pageType } = this.props;

    getCommonPageText(pageType)
      .then((text) => {
        this.setState({
          pageText: text,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        // eslint-disable-next-line no-console
        if (__DEVELOPMENT__) console.log('Failed:', error);
      });
  }


  render() {
    const {
      pageText,
      isLoading,
    } = this.state;

    if (isLoading) return <Spinner className="top" />;

    return (
      <div
        className="CommonPageText"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: pageText }}
      />
    );
  }
}

CommonPageText.propTypes = {
  pageType: PropTypes.string.isRequired,
};

export default CommonPageText;
